import _get from 'lodash/get'
import _toPath from 'lodash/toPath'
const localeGet = (data, path, locale) => {
  const fullPath = [..._toPath(path), locale]
  const localeData = _get(data, fullPath)
  return localeData || _get(data, [..._toPath(path), 'en'])
}
export default localeGet
